import { GetStatementsApiParameter } from "@bToC/Services/StatementService";
import { CustomActions } from "@bToC/Store/Reducers";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<GetStatementsApiParameter & UpdateSearchFieldsType, DispatchProp<CustomActions>>;

export const DispatchUpdateSearchFields: HandlerType = props => {
    props.dispatch({
        type: "CustomPages/Statements/UpdateSearchFields",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateSearchFields];

const updateSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateSearchFields");
export default updateSearchFields;
